import React, { Component } from 'react'
import { Input } from '@driftt/tide-core'
import AppMonitorTable from './AppMonitorTable'
import './style.css'

const TEST_DATA = [
  {
    severityLevel: 'info',
    timestamp: 'Nov 21, 2017 2:17 PM',
    description: 'This here is a fine app. It works well all the time. This here is a fine app. It works well all the time. This here is a fine app. It works well all the time.'
  },
  {
    severityLevel: 'warning',
    timestamp: 'Nov 22, 2017 2:18 PM',
    description: 'This here is almost a fine app. It works well most of the time. This here is almost a fine app. It works well most of the time. This here is almost a fine app. It works well most of the time.'
  },
  {
    severityLevel: 'error',
    timestamp: 'Nov 23, 2017 2:19 PM',
    description: 'This here is a no good app. It sucks big time. This here is a no good app. It sucks big time. This here is a no good app. It sucks big time. This here is a no good app. It sucks big time.'
  }
]

class AppMonitor extends Component {

  state = {
    isLoading: false,
    isSearching: false
  }

  render() {
    const { isLoading, isSearching } = this.state

    return (
      <div className="app-monitor">
        <span className="page-title">
          Monitor Your App
        </span>
        <p className="page-description">
          We’ll report any errors from your app in this handy dandy table below.
        </p>
        <Input type="search" placeholder="Search..." className="app-monitor-search" />
        <AppMonitorTable
          isLoading={isLoading}
          isSearching={isSearching}
          data={TEST_DATA}
        />
      </div>
    )
  }
}

export default AppMonitor
